import RpcClass from "../../../../../../server/RpcClass.js";

import yaml from "js-yaml"

import RpcNotFoundException from "../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

import DictionaryEntity from "../../../../../../server/com/silkplm/engine/entities/DictionaryEntity.js";
let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.model.plm.dictionaries.ComponentIndex';

import LocalDate from "../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../server/LocalTime.js";



class ComponentIndex extends DictionaryEntity {

    /**
     *  @class ComponentIndex
     *  @alias module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex
     *  
     * */
    constructor(){
        super();

        /** @type {string}  */
        this.EID = null;
        /** @type {boolean}  */
        this.__archived = null;
        /** @type {number}  */
        this.__familyId = null;
        /** @type {boolean}  */
        this.__hidden = null;
        /** @type {number}  */
        this.__parent = null;
        /** @type {Date}  */
        this.__versionDate = null;
        /** @type {Object.<string, *>}  */
        this._translations = null;
        /** @type {boolean}  */
        this.active = null;
        /** @type {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}  */
        this.attachments = null;
        /** @type {string}  */
        this.category = null;
        /** @type {string}  */
        this.colorId = null;
        /** @type {string}  */
        this.comments = null;
        /** @type {boolean}  */
        this.completeTheComposition = null;
        /** @type {string}  */
        this.currentSelectedRegion = null;
        /** @type {boolean}  */
        this.defaultValue = null;
        /** @type {BigDecimal}  */
        this.fabricWidth = null;
        /** @type {string}  */
        this.fabricWidthString = null;
        /** @type {module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery}  */
        this.gallery = null;
        /** @type {string}  */
        this.grammage = null;
        /** @type {BigDecimal}  */
        this.height = null;
        /** @type {string}  */
        this.id = null;
        /** @type {BigDecimal}  */
        this.length = null;
        /** @type {string}  */
        this.locationInWarehouse = null;
        /** @type {string}  */
        this.material1 = null;
        /** @type {string}  */
        this.material2 = null;
        /** @type {string}  */
        this.material3 = null;
        /** @type {string}  */
        this.material4 = null;
        /** @type {string}  */
        this.material5 = null;
        /** @type {string}  */
        this.material6 = null;
        /** @type {string}  */
        this.materialId = null;
        /** @type {string}  */
        this.name = null;
        /** @type {string}  */
        this.notes = null;
        /** @type {string}  */
        this.pantoneColor = null;
        /** @type {string}  */
        this.performance = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.pricePerUnit = null;
        /** @type {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}  */
        this.recordMetadata = null;
        /** @type {string}  */
        this.sizeRange = null;
        /** @type {string}  */
        this.supplierId = null;
        /** @type {string}  */
        this.supplierProductId = null;
        /** @type {string}  */
        this.typeId = null;
        /** @type {string}  */
        this.unitId = null;
        /** @type {BigDecimal}  */
        this.value1 = null;
        /** @type {BigDecimal}  */
        this.value2 = null;
        /** @type {BigDecimal}  */
        this.value3 = null;
        /** @type {BigDecimal}  */
        this.value4 = null;
        /** @type {BigDecimal}  */
        this.value5 = null;
        /** @type {BigDecimal}  */
        this.value6 = null;
        /** @type {number}  */
        this.version = null;

        if(window["SessionManager"]?.isLoggedIn()){
            const formConfig = window['FormsLoader']?.detectFormConfig(FULL_CLASS);
            for(const f of formConfig.fields){
                if(f.formDisabled){
                    continue;
                }
                if( f.defaultValue !== null) {
                    this[f.fieldName] = yaml.load(f.defaultValue);
                }
             }
        }
    }




    /**
     * Get list of detail Component Index Product Component
     * @returns {Promise<ComponentIndexProductComponent[]>}
     */

    async listComponentIndexProductComponent(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.ComponentIndexProductComponent",
        "componentIndexId");
    }

    /** @type {string}  */
    get supplierIdSupplierCode(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['supplierIdSupplierCode'] : null, this.__metadata__['supplierIdSupplierCode']?.remoteType);
    }
    set supplierIdSupplierCode(val){
    }
    // fk: false

    /** @type {string}  */
    get productComponents(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productComponents'] : null, this.__metadata__['productComponents']?.remoteType);
    }
    set productComponents(val){
    }


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withEID(val){
        this.EID = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    with__archived(val){
        this.__archived = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    with__familyId(val){
        this.__familyId = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    with__hidden(val){
        this.__hidden = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    with__parent(val){
        this.__parent = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    with__versionDate(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.__versionDate = v;
        return this;
    };


    /**
     * @param val {Object.<string, *>}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    with_translations(val){
        this._translations = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withActive(val){
        this.active = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withAttachments(val){
        this.attachments = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withCategory(val){
        this.category = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCategoryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Category', 'category', allowRemote); //  true 
    }

    /** @returns {String} */
        getCategoryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Category', 'category'); //  true 
    }

        /** @returns {Promise<Category>} */
    getCategoryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Category', 'category', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withColorId(val){
        this.colorId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getColorIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Colors', 'colorId', allowRemote); //  true 
    }

    /** @returns {String} */
        getColorIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Colors', 'colorId'); //  true 
    }

        /** @returns {Promise<Colors>} */
    getColorIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Colors', 'colorId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withComments(val){
        this.comments = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withCompleteTheComposition(val){
        this.completeTheComposition = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withCurrentSelectedRegion(val){
        this.currentSelectedRegion = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withDefaultValue(val){
        this.defaultValue = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withFabricWidth(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.fabricWidth = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withFabricWidthString(val){
        this.fabricWidthString = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withGallery(val){
        this.gallery = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withGrammage(val){
        this.grammage = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withHeight(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.height = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withId(val){
        this.id = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withLength(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.length = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withLocationInWarehouse(val){
        this.locationInWarehouse = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withMaterial1(val){
        this.material1 = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getMaterial1Label(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Materials', 'material1', allowRemote); //  true 
    }

    /** @returns {String} */
        getMaterial1StaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Materials', 'material1'); //  true 
    }

        /** @returns {Promise<Materials>} */
    getMaterial1Entity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Materials', 'material1', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withMaterial2(val){
        this.material2 = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getMaterial2Label(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Materials', 'material2', allowRemote); //  true 
    }

    /** @returns {String} */
        getMaterial2StaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Materials', 'material2'); //  true 
    }

        /** @returns {Promise<Materials>} */
    getMaterial2Entity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Materials', 'material2', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withMaterial3(val){
        this.material3 = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getMaterial3Label(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Materials', 'material3', allowRemote); //  true 
    }

    /** @returns {String} */
        getMaterial3StaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Materials', 'material3'); //  true 
    }

        /** @returns {Promise<Materials>} */
    getMaterial3Entity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Materials', 'material3', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withMaterial4(val){
        this.material4 = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getMaterial4Label(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Materials', 'material4', allowRemote); //  true 
    }

    /** @returns {String} */
        getMaterial4StaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Materials', 'material4'); //  true 
    }

        /** @returns {Promise<Materials>} */
    getMaterial4Entity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Materials', 'material4', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withMaterial5(val){
        this.material5 = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getMaterial5Label(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Materials', 'material5', allowRemote); //  true 
    }

    /** @returns {String} */
        getMaterial5StaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Materials', 'material5'); //  true 
    }

        /** @returns {Promise<Materials>} */
    getMaterial5Entity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Materials', 'material5', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withMaterial6(val){
        this.material6 = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getMaterial6Label(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Materials', 'material6', allowRemote); //  true 
    }

    /** @returns {String} */
        getMaterial6StaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Materials', 'material6'); //  true 
    }

        /** @returns {Promise<Materials>} */
    getMaterial6Entity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Materials', 'material6', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withMaterialId(val){
        this.materialId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getMaterialIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Materials', 'materialId', allowRemote); //  true 
    }

    /** @returns {String} */
        getMaterialIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Materials', 'materialId'); //  true 
    }

        /** @returns {Promise<Materials>} */
    getMaterialIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Materials', 'materialId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withName(val){
        this.name = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withNotes(val){
        this.notes = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withPantoneColor(val){
        this.pantoneColor = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withPerformance(val){
        this.performance = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withPricePerUnit(val){
        this.pricePerUnit = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withRecordMetadata(val){
        this.recordMetadata = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withSizeRange(val){
        this.sizeRange = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSizeRangeLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.SizeRanges', 'sizeRange', allowRemote); //  true 
    }

    /** @returns {String} */
        getSizeRangeStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.SizeRanges', 'sizeRange'); //  true 
    }

        /** @returns {Promise<SizeRanges>} */
    getSizeRangeEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.SizeRanges', 'sizeRange', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withSupplierId(val){
        this.supplierId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSupplierIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Suppliers', 'supplierId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSupplierIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Suppliers', 'supplierId'); //  true 
    }

        /** @returns {Promise<Suppliers>} */
    getSupplierIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Suppliers', 'supplierId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withSupplierProductId(val){
        this.supplierProductId = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withTypeId(val){
        this.typeId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTypeIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TechnologicalProductType', 'typeId', allowRemote); //  true 
    }

    /** @returns {String} */
        getTypeIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TechnologicalProductType', 'typeId'); //  true 
    }

        /** @returns {Promise<TechnologicalProductType>} */
    getTypeIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TechnologicalProductType', 'typeId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withUnitId(val){
        this.unitId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getUnitIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Unit', 'unitId', allowRemote); //  true 
    }

    /** @returns {String} */
        getUnitIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Unit', 'unitId'); //  true 
    }

        /** @returns {Promise<Unit>} */
    getUnitIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Unit', 'unitId', allowRemote); //  true 
    }

    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withValue1(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.value1 = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withValue2(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.value2 = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withValue3(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.value3 = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withValue4(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.value4 = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withValue5(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.value5 = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withValue6(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.value6 = v;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/dictionaries/ComponentIndex.ComponentIndex}
     */
    withVersion(val){
        this.version = val;
        return this;
    };




    /**
    * @param {string[]?} fields
    * @returns {Promise<ComponentIndex>}
    */
    async save(fields){
        return this.__save(FULL_CLASS, fields);
    }

    async load(id=null){
        if(id == null){
            id = this.id;
        }
        let newVersion = await loadComponentIndex(id);
        for(const k in newVersion){
            this[k] = newVersion[k];
        }
    }
    /**
     * @return {Promise}
     */
    async delete(){
        return Rpc.Forms.deleteEntity(FULL_CLASS, this.id);
    }
    /**
     * @param {*|string} replacementIdOrInst
     * @return {Promise}
     */
    async deleteWithReplacement(replacementIdOrInst){
        if(replacementIdOrInst.hasOwnProperty('id')){
            replacementIdOrInst = replacementIdOrInst.id;
        }
        return Rpc.Forms.deleteEntityWithReplacement(FULL_CLASS, this.id, replacementIdOrInst);
    }
    /**
     * CAN_DELETE | SUGGEST_REPLACEMENT | FORCE_REPLACEMENT | DELETE_RESTRICTED | DELETE_NOT_PERMITTED
     * @return {Promise<String>>}
     */
    async canDelete(){
        return Rpc.Forms.canDeleteEntity(FULL_CLASS, this.id);
    }

    /**
     * @param fieldName
     * @returns {Promise<FieldValidationResult>}
     */
    async validateField(fieldName){
        return Rpc.Forms.validateField(FULL_CLASS, fieldName, this[fieldName], this.id);
    }

    /**
     * @returns {Promise<InputValidationResult>}
     */
    async checkConstraints(){
        return Rpc.Forms.checkConstraints(FULL_CLASS, this);
    }
    /** @returns {Promise<String>}*/
    async getFkFieldLabel(fiendName, allowRemote=false) {
        if(fiendName === 'category'){
            return this.getCategoryLabel(allowRemote);
        }
        if(fiendName === 'colorId'){
            return this.getColorIdLabel(allowRemote);
        }
        if(fiendName === 'material1'){
            return this.getMaterial1Label(allowRemote);
        }
        if(fiendName === 'material2'){
            return this.getMaterial2Label(allowRemote);
        }
        if(fiendName === 'material3'){
            return this.getMaterial3Label(allowRemote);
        }
        if(fiendName === 'material4'){
            return this.getMaterial4Label(allowRemote);
        }
        if(fiendName === 'material5'){
            return this.getMaterial5Label(allowRemote);
        }
        if(fiendName === 'material6'){
            return this.getMaterial6Label(allowRemote);
        }
        if(fiendName === 'materialId'){
            return this.getMaterialIdLabel(allowRemote);
        }
        if(fiendName === 'sizeRange'){
            return this.getSizeRangeLabel(allowRemote);
        }
        if(fiendName === 'supplierId'){
            return this.getSupplierIdLabel(allowRemote);
        }
        if(fiendName === 'typeId'){
            return this.getTypeIdLabel(allowRemote);
        }
        if(fiendName === 'unitId'){
            return this.getUnitIdLabel(allowRemote);
        }

        return '';
    }

    /** @returns {Promise<*>}*/
    async getFkFieldEntity(fiendName, allowRemote=false) {
        if(fiendName === 'category'){
            return this.getCategoryEntity(allowRemote);
        }
        if(fiendName === 'colorId'){
            return this.getColorIdEntity(allowRemote);
        }
        if(fiendName === 'material1'){
            return this.getMaterial1Entity(allowRemote);
        }
        if(fiendName === 'material2'){
            return this.getMaterial2Entity(allowRemote);
        }
        if(fiendName === 'material3'){
            return this.getMaterial3Entity(allowRemote);
        }
        if(fiendName === 'material4'){
            return this.getMaterial4Entity(allowRemote);
        }
        if(fiendName === 'material5'){
            return this.getMaterial5Entity(allowRemote);
        }
        if(fiendName === 'material6'){
            return this.getMaterial6Entity(allowRemote);
        }
        if(fiendName === 'materialId'){
            return this.getMaterialIdEntity(allowRemote);
        }
        if(fiendName === 'sizeRange'){
            return this.getSizeRangeEntity(allowRemote);
        }
        if(fiendName === 'supplierId'){
            return this.getSupplierIdEntity(allowRemote);
        }
        if(fiendName === 'typeId'){
            return this.getTypeIdEntity(allowRemote);
        }
        if(fiendName === 'unitId'){
            return this.getUnitIdEntity(allowRemote);
        }
        return null;
    }


    /**
     * @param {string} externalSystemName
     * @returns {Promise<string>}
     */
    async externalId(externalSystemName){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, this.id, externalSystemName);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async loadByExternalId(externalSystemName, externalId){
    //clazzName, silkId, extSystem
        let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
        if(res.recordStatus !== "EXISTS"){
            throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
        }
        await this.load(res.silkId);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async bindExternalId(externalSystemName, externalId){
      //clazzName, extId, extSystem, silkId
      return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, this.id);
   }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async removeExternalId(externalSystemName, externalId){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, this.id);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @returns {Promise<string>}
     */
    async readBoundValue(externalSystemName, keyName){
      let res = await Rpc.Integrations.readObjectData(FULL_CLASS, this.id, externalSystemName, keyName);
      return JSON.parse(res);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @param {Object} val
     * @returns {Promise<>}
     */
    async bindValue(externalSystemName, keyName, val){
      return Rpc.Integrations.storeObjectData(FULL_CLASS, externalSystemName, this.id, keyName, val);
    }

    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}

/**
 * @param {string} id
 * @param {boolean?} loadFkObjects
 * @returns {Promise<ComponentIndex>}
 */
async function loadComponentIndex(id, loadFkObjects){
    if(loadFkObjects){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<ComponentIndex[]>}
 */
async function listComponentIndex(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @param {string} id
 * @returns {Promise<string>}
 */
async function labelComponentIndex(id){
    return Rpc.Forms.getEntityLabel(FULL_CLASS, id);
}
// STATICS --------------------------------------

/**
 * @param {string} id
 * @param {boolean?} loadDetails
 * @returns {Promise<ComponentIndex>}
 */
ComponentIndex.load = async function(id, loadDetails=false){
    if(loadDetails){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<ComponentIndex[]>}
 */
ComponentIndex.list = async function(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @returns {Promise<ComponentIndex[]>}
 */
ComponentIndex.listExtended = async function(){
    return Rpc.Forms.listExtendedEntities(FULL_CLASS);
}

/**
 * @returns {Promise<ComponentIndex[]>}
 */
ComponentIndex.getRemoteClass = function(){
    return FULL_CLASS;
}

/**
 * @param {string} externalSystem
 * @param {string} extId
 * @param {boolean?} loadDetails
 * @returns {Promise<ComponentIndex>}
 */
ComponentIndex.loadByExternalId = async function(externalSystem, extId, loadDetails=false){

    let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, extId, externalSystem);
    if(res.recordStatus !== "EXISTS"){
        throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
    }
    return ComponentIndex.load(res.silkId, loadDetails);
}


// INTEGRATIONS --------------------------------

/**
 * @param {string} externalSystemName
 * @param {string} silkId
 * @returns {Promise<IdMapping>}
 */
ComponentIndex.bindingFromSilkId = async function(externalSystemName, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, silkId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<IdMapping>}
 */
ComponentIndex.bindingFromExternalId = async function(externalSystemName, externalId){
    //clazzName, silkId, extSystem
    return  Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @param {string} silkId
 * @returns {Promise<>}
 */
ComponentIndex.bindExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, extId, extSystem, silkId
    return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<>}
 */
ComponentIndex.removeExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {IdMapping} binding
 * @returns {Promise<>}
 */
ComponentIndex.removeExternalBinding = async function(binding){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, binding.externalId, binding.externalSystem, binding.silkId);
}



let metadata = {};
metadata['EID'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['__archived'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__familyId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__hidden'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__parent'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__versionDate'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['_translations'] = {'remoteType' : 'Object.<string, *>', 'jsType' : 'Object.<string, *>', 'mapped' : 'false'};
metadata['active'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['attachments'] = {'remoteType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'jsType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'mapped' : 'false'};
metadata['category'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['colorId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['comments'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['completeTheComposition'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['currentSelectedRegion'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['defaultValue'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['fabricWidth'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['fabricWidthString'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['gallery'] = {'remoteType' : 'module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery', 'jsType' : 'module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery', 'mapped' : 'false'};
metadata['grammage'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['height'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['id'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['length'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['locationInWarehouse'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['material1'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['material2'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['material3'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['material4'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['material5'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['material6'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['materialId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['name'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['notes'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['pantoneColor'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['performance'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['pricePerUnit'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['recordMetadata'] = {'remoteType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'jsType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'mapped' : 'false'};
metadata['sizeRange'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierProductId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['typeId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['unitId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['value1'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['value2'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['value3'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['value4'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['value5'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['value6'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['version'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['productComponents'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierIdSupplierCode'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.model.plm.dictionaries.ComponentIndex';
metadata.__type_short__ = 'ComponentIndex';
ComponentIndex.prototype.__metadata__ = metadata;

ComponentIndex.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/model/plm/dictionaries/ComponentIndex */
export default ComponentIndex

export { ComponentIndex , loadComponentIndex, listComponentIndex, labelComponentIndex }
